<template>
  <div id="center-cmp-info">
    <div class="cc-header">
      <digital-flop />
    </div>

    <div class="cc-details">
      <div class="details-left">
        <div style="font-size: 0.9em;">实时参与桶数</div>
        <num-draw />
      </div>
      <div class="details-right">
        <div class="card-item">
          <dv-charts class="ring-charts" :option="ring1" />
          <div class="card-footer">
            <div class="card-footer-item">
              <div class="footer-title">正确率</div>
              <div class="footer-detail">
                <dv-digital-flop :config="total1" style="width:70%;height:35px;" />%
              </div>
            </div>
            <div class="card-footer-item">
              <div class="footer-title">正确户数</div>
              <div class="footer-detail">
                <dv-digital-flop :config="num1" style="width:70%;height:35px;" />户
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

  import digitalFlop from './digitalFlop';
  import NumDraw from './NumDraw'

export default {
  name: 'CenterCmp',
  components: {
    digitalFlop,
    NumDraw
  },
  data () {
    return {
      ring1: null,
      total1: null,
      num1: null
    }
  },
  methods:{
    createData(){
      const {config1} = this;
      let streetId = localStorage.getItem("streetId")
      if (!streetId) {
        streetId = JSON.parse(localStorage.getItem("USER")).streetId;
      }
      let params = {'streetId': streetId};
      this.$get('/data/garbage_sorting',{
        ...params
      }).then((r) => {
        let data = r.data;
        if (data.code != 200){
          alert('权限不足');
        } else {
          let data = r.data.data;
          // 总户数
          let userCount = data.usercount;
          // 总收集户数
          let gather = data.garbageSorting.gatherRate;
          // 不合格户数
          let unqualified = data.garbageSorting.unqualifiedRate;
          // 空桶户数
          let empty = data.garbageSorting.emptyRate;
          // 正确户数
          let correct = gather - unqualified;

          // 正确收集率
          let correctRate = 0;
          if(gather != 0){
            correctRate = (correct / gather) * 100;
          }
          config1(correctRate,gather);
        }
      })
    },
    config1(valueRate,value){
      let ring1 = {
        series: [
          {
            type: 'gauge',
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 15,
            radius: '85%',
            center: ['50%','50%'],
            data: [
              { name: '正确率占比', value: valueRate }
            ],
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show: false
            },
            backgroundArc: {
              style: {
                stroke: '#224590'
              }
            },
            details: {
              show: true,
              formatter: '正确率占比{value}%',
              style: {
                fill: '#1ed3e5',
                fontSize: 14
              }
            }
          }
        ],
        color: ['#03d3ec']
      };

      let total1 = {
        number: [valueRate],
        content: '{nt}',
        textAlign: 'right',
        style: {
          fill: '#ea6027',
          fontWeight: 'bold'
        }
      };

      let num1 = {
        number: [value],
        content: '{nt}',
        textAlign: 'right',
        style: {
          fill: '#26fcd8',
          fontWeight: 'bold'
        }
      };
      this.ring1 = ring1;
      this.total1 = total1;
      this.num1 = num1;
    }
  },
  mounted() {
    const {createData} = this;
    createData();
    const timer = setInterval(createData, 100000);
    this.$once('hook:beforeDestroy',function () {
      clearInterval(timer);
    });
  }
}
</script>

<style scoped lang="less">
#center-cmp-info {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 20px;
  display: flex;
  flex-direction: column;

  .cc-header {
    height: 30%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 28px;
  }

  .cc-details{
    width: 100%;
    height: 100%;
    display: flex;
  }

  .cc-details .details-left {
    background-color: rgba(6, 30, 93, 0.5);
    border-top: 2px solid rgba(1, 153, 209, .5);
    width: 100%;
    height: 96%;
    display: flex;
    justify-content: center;
    font-size: 30px;
    align-items: center;
    margin: 6px;

    .card {
      background-color: rgba(4,49,128,.6);
      color: #08e5ff;
      height: 70px;
      width: 70px;
      font-size: 40px;
      font-weight: bold;
      line-height: 70px;
      text-align: center;
      margin: 10px;
    }
  }

  .cc-details .details-right{
    width: 100%;
    height: 100%;
    padding: 5px;

    .card-item{
      background-color: rgba(6, 30, 93, 0.5);
      border-top: 2px solid rgba(1, 153, 209, .5);
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .ring-charts{
      height: 55%;
    }

    .card-footer{
      height: 45%;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }

    .card-footer-item {
      padding: 5px 10px 0px 10px;
      box-sizing: border-box;
      width: 40%;
      background-color: rgba(6, 30, 93, 0.7);
      border-radius: 3px;

      .footer-title {
        font-size: 0.9em;
        margin-bottom: 5px;
      }

      .footer-detail {
        font-size: 20px;
        color: #1294fb;
        display: flex;
        font-size: 18px;
        align-items: center;

        .dv-digital-flop {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/datav/CenterCmp.vue